module.exports = __webpack_public_path__ + "img/collection-weddingRingsPlain.41eb652.jpg";